// R1 — shared artist helpers.

// Full display name (stage name, else name). Never split to a first word.
export const artistName = (a) =>
  String(a?.stage_name || a?.name || a?.artist_name || 'the artist').trim();

// Rating filters only make sense once at least one listed artist has a review.
export const hasReviews = (artists = []) =>
  artists.some((a) => Number(a?.total_reviews || 0) >= 1);
